module.exports = __webpack_public_path__ + "media/images/edion/popular/5-142959eedd20b783da086e1b9bea2704.png";